import React, { useState } from 'react';
import { X, Mail, User, Rocket } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { toast } from 'sonner';

export const EarlyAccessModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}api/newsletter/early-access`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,}),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        toast.success(data.message || 'Thank you! You\'re on the early access list.');
        setFormData({ name: '', email: '' });
        setTimeout(() => {
          onClose();
        }, 1500);
      } else {
        toast.error(data.detail || 'Failed to register. Please try again.');
      }
    } catch (error) {
      console.error('Early access signup error:', error);
      toast.error('Failed to register. Please check your connection and try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-in fade-in duration-200">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full relative animate-in zoom-in-95 duration-200">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-100 transition-colors"
          aria-label="Close"
        >
          <X size={20} className="text-gray-500" />
        </button>

        {/* Modal Content */}
        <div className="p-8">
          {/* Icon */}
          <div className="w-20 h-20 bg-gradient-to-br from-[#FF9933] to-[#E68A2E] rounded-full flex items-center justify-center mx-auto mb-6">
            <Rocket className="text-white" size={36} />
          </div>

          {/* Title */}
          <h2 className="text-3xl font-bold text-[#1B4F72] text-center mb-3">
            Get Early Access
          </h2>
          <p className="text-gray-600 text-center mb-8">
            Join the waitlist and be among the first to experience India's unified mobility platform
          </p>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="modal-name" className="text-[#1B4F72] font-semibold">
                Full Name
              </Label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
                <Input
                  id="modal-name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your name"
                  className="pl-10 border-gray-300 focus:border-[#FF9933] focus:ring-[#FF9933]"
                />
              </div>
            </div>

            <div className="space-y-2">
              <Label htmlFor="modal-email" className="text-[#1B4F72] font-semibold">
                Email Address *
              </Label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
                <Input
                  id="modal-email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="you@example.com"
                  required
                  className="pl-10 border-gray-300 focus:border-[#FF9933] focus:ring-[#FF9933]"
                />
              </div>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[#FF9933] hover:bg-[#E68A2E] text-white font-semibold py-6 text-lg shadow-lg transition-all duration-300 hover:scale-105"
            >
              {loading ? 'Joining...' : 'Join Waitlist'}
            </Button>
          </form>

          <p className="text-sm text-gray-500 text-center mt-6">
            No spam. Early access updates only.
          </p>
        </div>
      </div>
    </div>
  );
};
